import { createContext } from 'react';
export const ContextForm = createContext({});
export const ContextSocialLogin = createContext({});
